import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
}), React.createElement("path", {
  d: "M17 7L2 22h15z"
})), 'NetworkCell');